import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';

export default function HeaderTooltip({ children, ...props }) {
  return (
    <Tooltip
      placement="bottom"
      PopperProps={{ disablePortal: true }}
      {...props}
    >
      {children}
    </Tooltip>
  );
}

HeaderTooltip.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.node.isRequired
};